import { render, staticRenderFns } from "./DcvInstruction.vue?vue&type=template&id=5a29c058"
import script from "./DcvInstruction.vue?vue&type=script&lang=ts"
export * from "./DcvInstruction.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports